import React from 'react';
import { Star } from 'lucide-react';
export const TestimonialSlider = () => {
  const testimonials = [{
    text: 'Brilliant same-day response. Engineer was polite and fixed our washer in one visit.',
    author: 'J. Turner, Manchester'
  }, {
    text: 'Clear pricing and tidy work. No mess left behind. Would definitely use again.',
    author: 'A. Patel, Birmingham'
  }, {
    text: 'Fixed our washer first visit. Very professional and explained everything clearly.',
    author: 'S. Bennett, Leeds'
  }, {
    text: 'Excellent service from start to finish. Engineer arrived on time and was very knowledgeable.',
    author: 'M. Davies, Cardiff'
  }];
  return <div className="bg-white py-16" data-id="element-198">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-199">
        <h2 className="text-3xl font-bold text-slate-800 text-center mb-12" data-id="element-200">
          What Our Customers Say
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-201">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-slate-50 p-6 rounded-xl border-l-4 border-blue-500" data-id="element-202">
              <div className="flex items-center mb-3" data-id="element-203">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-204" />)}
              </div>
              <p className="text-slate-700 mb-3" data-id="element-205">"{testimonial.text}"</p>
              <p className="text-slate-500 font-medium text-sm" data-id="element-206">
                — {testimonial.author}
              </p>
            </div>)}
        </div>
      </div>
    </div>;
};